class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, this.inputDebounceDelay).bind(this)
      );
    }

    if (this.resetButton) {
      // We use 'true' to put this on the CAPTURE phase.
      // This lets us intercept the click before anything else.
      this.resetButton.addEventListener('click', this.onResetButtonClick.bind(this), true); 
    }
  }

  get inputDebounceDelay() {
    return 300;
  }

  onResetButtonClick(event) {
    // Check if we are inside the mobile menu
    const isMobileMenu = this.closest('#menu-drawer');

    if (isMobileMenu) {
      // We are on mobile. Hijack this click completely.
      
      // 1. Stop the event so the mobile menu's
      //    listener never even sees it.
      event.stopImmediatePropagation();
      
      // 2. Stop the default 'reset' action from firing.
      event.preventDefault();

      // 3. Manually clear the input and toggle the button.
      this.input.value = '';
      this.toggleResetButton();

      // --- START THE FIX ---
      // 4. Manually call 'closeResults' (if it exists).
      // This is the function in predictive-search.js
      // that closes the results dropdown.
      if (typeof this.closeResults === 'function') {
        this.closeResults(true); // 'true' clears results & searchTerm
      }
      // --- END THE FIX ---
    }
    
    // If not on mobile, this function does nothing,
    // and the default 'reset' event fires as normal.
  }

  toggleResetButton() {
    if (!this.resetButton) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // This function will now ONLY run on desktop,
    // because the mobile click is caught by onResetButtonClick.
    
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
